<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/gaoyabianping" />
          <div class="ProductImages">
              <div class="image-div">
                <img :src="baseApi+ 'upload/product/1001.png'">
              </div>
            <div class="image-div">
                <img :src="baseApi+ 'upload/product/1002.png'">
                <img :src="baseApi+ 'upload/product/1003.png'">
              </div>
            <div class="image-div">
              <img :src="baseApi+ 'upload/product/1004.png'">
              <img :src="baseApi+ 'upload/product/1005.png'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  display: flex;
  .image-div {
    width: 30%;
    margin: 10px;
    img {
      width: 100%;
      margin: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/gaoyabianping.vue